export default "__VITE_ASSET__qhkfAFN0__"